import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

// Actions
import { UpdateWorkHours } from '../../../actions/employees'
import { triggerPopup } from '../../../actions/backdrop'

// import styles
import './workhours.scss'

// elements
import Panel from '../../../shared/elements/panel'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Radio from '../../../shared/elements/radio'
import Grid from '../../../shared/elements/grid'
import Text from '../../../shared/elements/text'
import DateTime from '../../elements/datetime'
import Inline from '../../elements/inline'
import Divider from '../../elements/divider'
import Icon from '../../elements/icon'
import { ElementIcons } from '../../elements/icons'
import Actions from '../../elements/actions'
import HelpIcon from '../../elements/helpIcon'

// Utils
import { padNumber, renderFullDate, setHourMin } from '../../../utils/time'
import { translation } from '../../../utils/helpers'
import { cloneDeep } from 'lodash'

// Modals
import WorkhoursModal from '../../../shared/modals/WorkhourModal'

class WorkHours extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Hours: {},
      ShowHourWindow: false,
      IsHourWindowHistory: false,
      EditPauseType: 0
    }

    this.onRadioChange = this.onRadioChange.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onInputHourChange = this.onInputHourChange.bind(this)
    this.ToggelHourWindow = this.ToggelHourWindow.bind(this)
    this.onChangeDate = this.onChangeDate.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.setState({
      Hours: cloneDeep(this.props.WorkHours)
    }, () => {
      let EditPauseType = this.state.Hours.PauseType
      if (!this.props.onlyShow) {
        this.setState({
          Hours: {
            ...this.state.Hours,
            Date: new Date()
          },
          EditPauseType: EditPauseType
        })
      }
    })

    if (!this.props.onlyShow && this.props.setBottomBarProps) {
      this.props.setBottomBarProps({
        actionLabelText: translation('14732'),
        onActionClick: this.onSave,
        cancelLabelText: translation('1155'),
        onCancelClick: this.props.onClose
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      Hours: {
        ...cloneDeep(nextProps.WorkHours)
      }
    })
  }

  onRadioChange (e) {
    let value = parseInt(e.target.value)
    let name = e.target.name
    this.setState({
      [name]: value
    })
  }

  onInputHourChange (e) {
    let Hours = this.state.Hours
    let value = ''
    let name = e.target.name
    let val = e.target.value

    let sub = val.substr(1, 1)
    let sub2 = val.substr(2, 1)
    if (isNaN(parseInt(sub))) {
      if (sub !== ':' && sub !== '') {
        val = val.replace(sub, ':')
      }
    }
    if (isNaN(parseInt(sub2))) {
      if (sub2 !== ':' && sub2 !== '') {
        val = val.replace(sub2, ':')
      }
    }
    val = val.replace('::', ':')
    let datetimeFormat = Hours[name]
    if (datetimeFormat === null) datetimeFormat = '2000-01-01T00:00:00'
    value = setHourMin(datetimeFormat, val)

    this.setState({
      Hours: {
        ...this.state.Hours,
        [name]: value
      }
    })
  }

  onBlur (e) {
    let name = e.target.name

    let day = name.substr(0, (name.indexOf('day') + 3))
    let start = this.state.Hours[day + 'StartTime']
    let end = this.state.Hours[day + 'EndTime']

    let time = (start.endsWith('T') || end.endsWith('T')) ? 0 : moment(end, 'YYYY-MM-DD HH:mm').diff(moment(start, 'YYYY-MM-DD HH:mm'))
    time = time > 0 ? time / 3600000 : 0.0

    this.setState({
      Hours: {
        ...this.state.Hours,
        [day]: time
      }
    })
  }

  render () {
    if (this.state.Hours === undefined || this.state.Hours.Monday === undefined) return null
    var allWorkHours = Number(this.state.Hours.Monday * 60) + Number(this.state.Hours.Tuesday * 60) + Number(this.state.Hours.Wednesday * 60) + Number(this.state.Hours.Thursday * 60) + Number(this.state.Hours.Friday * 60) + Number(this.state.Hours.Saturday * 60) + Number(this.state.Hours.Sunday * 60)
    var allPauseHours = (Number(this.state.Hours.MondayPause) + Number(this.state.Hours.TuesdayPause) + Number(this.state.Hours.WednesdayPause) + Number(this.state.Hours.ThursdayPause) + Number(this.state.Hours.FridayPause) + Number(this.state.Hours.SaturdayPause) + Number(this.state.Hours.SundayPause)) / 60

    var allWorkMinutes = allWorkHours
    var allPauseMinutes = allPauseHours * 60
    var wageMinutes = allWorkMinutes - allPauseMinutes

    const cols = [ 2 ]

    const formatMinutes = (minutes) => {
      minutes = Math.round(minutes)
      let hours = Math.floor(minutes / 60)
      let min = Math.round(minutes % 60)
      return padNumber(hours, 2) + ':' + padNumber(min, 2)
    }

    const formatWorkHourTimes = (datetime) => {
      if (datetime === null || datetime === undefined || datetime.length < 11) return ''
      return datetime.substring(11, 16)
    }

    const renderWorkDay = (label, name) => {
      const startNameProp = name + 'StartTime'
      const endNameProp = name + 'EndTime'
      const pauseNameProp = name + 'Pause'

      if (this.props.onlyShow) {
        return (
          <Grid cols={cols} rowSpan='2' align='center'>
            <span>{label}</span>
            <span>{formatWorkHourTimes(this.state.Hours[startNameProp])}</span>
            <span>{formatWorkHourTimes(this.state.Hours[endNameProp])}</span>
            <span>{formatMinutes(this.state.Hours[name] * 60)}</span>
            <span>{this.state.Hours[pauseNameProp] || ''}</span>
          </Grid>
        )
      }

      return (
        <Grid cols={cols} rowSpan='2' align='center'>
          <span>{label}</span>
          <Text name={startNameProp} value={formatWorkHourTimes(this.state.Hours[startNameProp])} onChange={this.onInputHourChange} onBlur={this.onBlur} disabled={this.props.onlyShow} maxLength='5' size='s' simple />
          <Text name={endNameProp} value={formatWorkHourTimes(this.state.Hours[endNameProp])} onChange={this.onInputHourChange} onBlur={this.onBlur} disabled={this.props.onlyShow} maxLength='5' size='s' simple />
          <span>{formatMinutes(this.state.Hours[name] * 60)}</span>
          <Text name={pauseNameProp} value={this.state.Hours[pauseNameProp] || ''} onChange={this.onInputChange} disabled={this.props.onlyShow} maxLength='3' size='s' simple />
        </Grid>
      )
    }

    const renderContainer = (content) => {
      // if (this.props.IsLog) {
      //   return (
      //     <div>
      //       <Header text={translation('453')} />
      //       <Divider />
      //       {content}
      //     </div>
      //   )
      // }

      return (
        <Panel title={translation('453')}>
          <Actions>
            {(this.props.onlyShow && this.props.IsLog !== true) && (
              <Icon icon={ElementIcons.Edit} onClick={this.ToggelHourWindow} size='t' />
            )}
          </Actions>

          {content}
        </Panel>
      )
    }

    const renderContent = () => {
      return (
        <div className='WorkHours'>
          <div>
            <Grid cols={cols}>
              <span />
              <label><div className='icon hint--bottom' aria-label={translation('2202')}><img className='icon' src='/images/icons/working-hour-16x16.png' /></div> <HelpIcon helpText={translation('2204')} /></label>
              <label><div className='icon hint--bottom' aria-label={translation('2203')}><img className='icon' src='/images/icons/Fyraften-16x16.png' /></div> <HelpIcon helpText={translation('2205')} /></label>
              <label><div className='icon hint--bottom' aria-label={translation('469')}><img className='icon' src='/images/icons/My-hours-Black-16x16.png' /></div> <HelpIcon helpText={translation('1977')} /></label>
              <label><div className='icon hint--bottom' aria-label={translation('468')}><img className='icon' src='/images/icons/Pause-Black-16x16.png' /></div> <HelpIcon helpText={translation('1978')} /></label>
            </Grid>
            {renderWorkDay(translation('169'), 'Monday')}
            {renderWorkDay(translation('170'), 'Tuesday')}
            {renderWorkDay(translation('171'), 'Wednesday')}
            {renderWorkDay(translation('172'), 'Thursday')}
            {renderWorkDay(translation('173'), 'Friday')}
            {renderWorkDay(translation('174'), 'Saturday')}
            {renderWorkDay(translation('175'), 'Sunday')}
            <Grid cols={cols} rowSpan='2' align='center'>
              <label className='weeklyHoursLabel'>{translation('452')}</label>
              <span />
              <span />
              <label className='count_all'>{formatMinutes(allWorkMinutes)}</label>
              <label className='count_all'>{formatMinutes(allPauseMinutes)}</label>
            </Grid>

            <Divider noLine />

            <LabelWrapper labelText={translation('1817')} helpText={translation('1979')}>
              {this.props.onlyShow && <Radio name='PauseType' value={0} checked={this.state.Hours.PauseType === 0} disabled={this.props.onlyShow} labelText={translation('463')} />}
              {this.props.onlyShow && <Radio name='PauseType' value={1} checked={this.state.Hours.PauseType === 1} disabled={this.props.onlyShow} labelText={translation('464')} />}
              {this.props.onlyShow && <Radio name='PauseType' value={2} checked={this.state.Hours.PauseType === 2} disabled={this.props.onlyShow} labelText={translation('460')} />}

              {!this.props.onlyShow && <Radio name='EditPauseType' value={0} checked={this.state.EditPauseType === 0} onChange={this.onRadioChange} disabled={this.props.onlyShow} labelText={translation('463')} />}
              {!this.props.onlyShow && <Radio name='EditPauseType' value={1} checked={this.state.EditPauseType === 1} onChange={this.onRadioChange} disabled={this.props.onlyShow} labelText={translation('464')} />}
              {!this.props.onlyShow && <Radio name='EditPauseType' value={2} checked={this.state.EditPauseType === 2} onChange={this.onRadioChange} disabled={this.props.onlyShow} labelText={translation('460')} />}
            </LabelWrapper>

            {this.props.onlyShow ? (
              <Grid spacing={1}>
                <span>{translation('14733')}</span>
                <span>{renderFullDate(this.state.Hours.Date, false)}</span>
              </Grid>
            ) : (
              <DateTime
                labelText={translation('14733')}
                dateFormat='DD-MM-YYYY'
                closeOnSelect
                timeFormat={false}
                value={this.state.Hours.Date}
                onChange={this.onChangeDate.bind(this, 'Date')} />
            )}

            {this.state.ShowToDate && (
              <Grid spacing={1}>
                <span>{translation('187')}</span>
                <span>{renderFullDate(this.state.ShowToDate, false)}</span>
              </Grid>
            )}

            {(this.props.onlyShow && this.props.IsLog !== true && this.props.LogCount > 1) && (
              <Icon icon={ElementIcons.Log_Icon} onClick={this.ToggelHourWindow.bind(this, 'true')} />
            )}
          </div>

          <Inline fillChildNum={[0]} block>
            <LabelWrapper labelText={translation('547')} />
            <span>{formatMinutes(wageMinutes)}</span>
          </Inline>

          {this.state.ShowHourWindow && <WorkhoursModal SetWorkHours={this.props.setWorkHours.bind(this)} UserId={this.state.Hours.UserId} onClose={this.ToggelHourWindow} IsHistory={this.state.IsHourWindowHistory} />}
        </div>
      )
    }

    return (this.props.InModal !== true /* || this.props.IsLog */) ? renderContainer(renderContent()) : renderContent()
  }

  onInputChange (name, e) {
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (typeof e === 'undefined') {
        e = name
      }
      name = e.target.name
      value = e.target.value
    }
    this.setState({
      Hours: {
        ...this.state.Hours,
        [name]: value
      }
    })
  }

  onChangeDate (name, e) {
    let value = e
    this.setState({
      Hours: {
        ...this.state.Hours,
        [name]: value
      }
    })

    let date = ''
    let val = new Date(value)
    let dates = this.props.Dates
    for (let i = dates.length, j = 0; i > j; i--) {
      if (new Date(dates[i]) > val) {
        date = dates[i]
      }
    }
    this.setState({
      ShowToDate: date
    })
  }

  ToggelHourWindow (IsHistory) {
    this.props.triggerPopup(!this.state.ShowHourWindow)

    this.setState({
      ShowHourWindow: !this.state.ShowHourWindow,
      IsHourWindowHistory: IsHistory === 'true'
    })
  }

  onSave () {
    let data = {
      UserId: this.state.Hours.UserId,
      WorkHour: {
        ...this.state.Hours,
        PauseType: this.state.EditPauseType
      }
    }

    this.props.UpdateWorkHours(data).then((res) => {
      this.props.updateLogs(res.data)

      // window.toastr.success(translation('14766'), translation('13424'))
    }, () => {
      window.toastr.error(translation('14767'), translation('216'))
    })
  }
}

WorkHours.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { UpdateWorkHours, triggerPopup })(WorkHours)



// WEBPACK FOOTER //
// ./src/app/shared/components/Workhours/index.js